import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "./firebase";

export interface UploadResult {
  fullPath: string;
  gsUrl: string;
  name: string;
  size: number;
  contentType: string;
}

/**
 * Upload a file to the quarantine bucket path for a user
 */
export async function uploadToQuarantine(
  userId: string,
  file: File,
): Promise<UploadResult> {
  const fileExt = file.name.split(".").pop() || "dat";
  const uniqueName = `${Date.now()}_${Math.random().toString(36).substring(2, 9)}.${fileExt}`;
  const quarantinePath = `quarantine/${userId}/${uniqueName}`;
  const storageRef = ref(storage, quarantinePath);

  const snapshot = await uploadBytes(storageRef, file, {
    contentType: file.type,
    customMetadata: {
      originalName: file.name,
      uploadedBy: userId,
    },
  });

  const bucketName =
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    "mlc-bug-tracking-attachments";

  return {
    fullPath: snapshot.metadata.fullPath,
    gsUrl: `gs://${bucketName}/${snapshot.metadata.fullPath}`,
    name: file.name,
    size: file.size,
    contentType: file.type,
  };
}

/**
 * Get download URL for an attachment (for demo / client retrieval)
 */
export async function getAttachmentDownloadUrl(path: string): Promise<string> {
  const cleanPath = path.startsWith("gs://")
    ? path.replace(/^gs:\/\/[^/]+\//, "")
    : path;
  const storageRef = ref(storage, cleanPath);
  return getDownloadURL(storageRef);
}
